export const getWallet = (state) => state.wallet || {}
